import o from"universal-cookie";class s{cookies;constructor(){this.cookies=new o}set(e){this.cookies=new o(e)}getCookies(){return this.cookies}}export{s as Cookies};
